<template>
  <div>
    <div class="tomb_page">
      <div class="head-topbar lite-page-top linebottom sticky">
        <div class="topbar-left"><i class="icon-arrow-left"></i></div>
        <div class="topbar-main">
          <h4>{{ pageTitle }}</h4>
        </div>
      </div>
      <div class="empty_main">
        <div class="empty empty-tips"><p class="empty-title">还没有创建纪念馆</p></div>
        <div class="create-tomb-btn" @click="goto">免费创建纪念馆</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'agreement',
  data() {
    return {
      pageName: '',
      pageTitle: '',
    }
  },
  created() {
    this.pageName = this.$route.params.type
  },
  mounted() {
    this.pageName = this.$route.params.type
  },
  methods: {
    goto() {
      this.$router.push({ path: '/jnt/create' })
    },
  },
  watch: {
    pageName() {
      if (this.pageName == 'sc') {
        this.pageTitle = '我收藏的纪念馆'
      } else if (this.pageName == 'create') {
        this.pageTitle = '我创建的纪念馆'
      } else if (this.pageName == 'friend') {
        this.pageTitle = '亲友团的纪念馆'
      }
    },
  },
}
</script>

<style>
.head-topbar.sticky {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
}
.head-topbar {
  display: flex;
  align-items: center;
  height: 3.8rem;
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 1;
}
.head-topbar .topbar-left {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.73333vw;
  position: absolute;
  left: 0.265rem;
  height: 100%;
  z-index: 10;
}
.head-topbar .topbar-left .icon-arrow-left {
  background: url(../../assets/jnt/zjt1.png) no-repeat;
  background-size: 100%;
  display: inline-block;
  height: 1.363rem;
  width: 0.818rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.head-topbar .topbar-main {
  flex: 1;
  color: #333;
  font-size: 1.454rem;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: 400;
}
.linebottom:after {
  content: '\20';
  position: absolute;
  z-index: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-bottom: 1px solid #eeeff3;
  -webkit-transform: scaleY(0.5) translate(0, 1px);
  -webkit-transform-origin: 0 0;
  transform: scaleY(0.5) translate(0, 1px);
  transform-origin: 0 0;
}
.empty_main {
  padding-top: 100px;
}
.empty_main .empty.empty-tips {
  margin-top: 10px;
  padding-top: 80px;
  padding-bottom: 30px;
  background: url(../../assets/jnt/ju1.png) no-repeat top;
  -webkit-background-size: 88px auto;
  background-size: 88px auto;
}
.empty_main .empty {
  margin-top: 40px;
  padding: 85px 60px 0;
  text-align: center;
}
.empty {
  margin-top: 40px;
  padding: 85px 60px 0;
  text-align: center;
}
.empty_main .empty .empty-title {
  -webkit-box-flex: 1;
  flex: 1;
  margin-left: 6px;
  margin-right: 3px;
  color: #363636;
  font-size: 1.3rem;
  line-height: 35px;
  color: #c4c3d0;
  font-size: 16px;
  padding-bottom: 0;
}

.create-tomb-btn {
  width: 145px;
  font-size: 1.3rem;
  height: 3rem;
  text-align: center;
  line-height: 3rem;
  color: #fff;
  border-radius: 20px;
  background: #e4803c;
  margin: 0 auto;
}
</style>
